<template>
    <div class="terms-wrapper">
        <app-header-mini :img="'/static/img/disclosure_policy/header.jpg'"></app-header-mini>
        <div class="terms-content">
            <h1 class="indent">Политика за предоставяне на информация</h1>
            <p class="indent">Политиката за предоставяне на информация от страна на АЛКОМЕТ АД е в пряка връзка с необходимостта на инвеститорите и акционерите й да получават актуална, адекватна и достатъчно изчерпателна и прозрачна информация. Професионалното и етичното отношение на АЛКОМЕТ АД към всички нейни контрагенти позиционира компанията като атрактивна инвестиция, като влияе пряко върху интереса към акциите й на пазара на ценни книжа.</p>
            <p class="indent">Ефективната програма за предоставяне на информация спомага за осъществяването на заложените още с регистрирането на дружеството на БФБ цели, а именно – по-добър достъп до инвестиции; подобряване маркетинга на продуктите и позиционирането на компанията като цяло; привличане на по-широк кръг бизнес контрагенти, доставчици и потенциални партньори за съвместни проекти; улесняване набирането на допълнителни средства чрез нови емисии ценни книжа и подготовка на капиталовия пазар за това; постигане на по-голяма гъвкавост и увереност на акционерите по отношение на техните инвестиции; по-ефективно използване на професионалните участници на капиталовия пазар за подобряване ликвидността на ценните книжа на дружеството; засилване медийното присъствие на дружеството в специализираните издания. </p>
            <p class="indent">Програмата ни за предоставяне на информация включва: финансови и оперативни резултати на дружеството; цели на дружеството; основни акционерни участия и право на глас; членове на Надзорния и Управителния съвет, ключови изпълнителни директори и техните отговорности; съществени предвидими рискови фактори; съществени въпроси, свързани със служителите или други заинтересовани лица; структура и политика на корпоративното управление.</p>
        </div>
    </div>
</template>

<script>
import HeaderMini from "./shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  }
};
</script>

<style scoped>
.terms-content {
  padding: 0 0 60px;
}
.terms-content > h1 {
  font-size: 34px;
  font-weight: 500;
  margin: 0 auto 25px;
  width: 800px;
}
.terms-content > p {
  font-size: 19px;
  text-align: justify;
  line-height: 32px;
  margin: 15px auto;
  width: 800px;
}
@media screen and (max-width: 1000px) {
  .terms-content > h1 {
    font-size: 20px;
    padding: 0 30px;
    width: 100%;
  }
  .terms-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DisclosurePolicy.vue